require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-chef-calamari-pop-up.json") })
        }
      }, "path---news-chef-calamari-pop-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-chef-calamari-pop-up!./.cache/json/news-chef-calamari-pop-up.json
// module id = 803
// module chunks = 231608221292675